import { Resource } from "../resource/resource.model";

/**
 * 4Bridge Connection Model
 * Represents a connection to an external system (Salesforce, Marketo, Eloqua, etc.)
 */
export class BridgeConnection extends Resource {
    name: string;
    connectorType: string;
    authType: string;
    /** @deprecated Use config and secrets instead */
    credentials?: any;
    /** Non-sensitive configuration data */
    config?: Record<string, any>;
    /** Decrypted secret values (returned on GetById for editing) */
    secrets?: Record<string, string>;
    /** Names of secret fields (for form rendering) */
    secretFieldNames?: string[];
    status?: string;
    statusMessage?: string;
    lastTestedAt?: Date;
    businessUnit?: string;
    description?: string;
    tags?: string[];
    createdAt?: Date;
    updatedAt?: Date;
    /**
     * True for connections auto-created by the system (e.g., 4Segments
     * destination provisioned at module activation). Edit/Delete should
     * be hidden in the UI when this is true. Backend may serialize as
     * either camelCase or snake_case depending on JSON naming policy.
     */
    isSystemManaged?: boolean;
    is_system_managed?: boolean;
}

/**
 * Request DTO for creating a connection
 */
export interface CreateConnectionRequest {
    name: string;
    connectorType: string;
    authType: string;
    /** @deprecated Use config and secrets instead */
    credentials?: Record<string, any>;
    /** Non-sensitive configuration */
    config?: Record<string, any>;
    /** Sensitive secrets (will be encrypted) */
    secrets?: Record<string, string>;
    businessUnit?: string;
    description?: string;
    tags?: string[];
}

/**
 * Request DTO for updating a connection
 */
export interface UpdateConnectionRequest {
    name?: string;
    connectorType?: string;
    authType?: string;
    /** @deprecated Use config and secrets instead */
    credentials?: Record<string, any>;
    /** Non-sensitive configuration */
    config?: Record<string, any>;
    /** Sensitive secrets (will be encrypted) */
    secrets?: Record<string, string>;
    /** Set to true to update secrets */
    updateSecrets?: boolean;
    businessUnit?: string;
    description?: string;
    tags?: string[];
}

/**
 * Response DTO for connection test
 */
export interface TestConnectionResponse {
    success: boolean;
    message: string;
}

/**
 * Connector types enum
 */
export enum ConnectorType {
    SALESFORCE = 'salesforce',
    MARKETO = 'marketo',
    ELOQUA = 'eloqua',
    HUBSPOT = 'hubspot',
    DYNAMICS = 'dynamics',
    CUSTOM = 'custom'
}

/**
 * Auth types enum
 */
export enum AuthType {
    OAUTH2 = 'oauth2',
    API_KEY = 'api_key',
    BASIC = 'basic',
    JWT = 'jwt'
}

/**
 * Connection status enum
 */
export enum ConnectionStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    ERROR = 'error',
    PENDING = 'pending'
}
